import { render, staticRenderFns } from "./RoyalExperienceShips.vue?vue&type=template&id=5aba067a&scoped=true"
import script from "./RoyalExperienceShips.vue?vue&type=script&lang=js"
export * from "./RoyalExperienceShips.vue?vue&type=script&lang=js"
import style0 from "./RoyalExperienceShips.vue?vue&type=style&index=0&id=5aba067a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba067a",
  null
  
)

export default component.exports